import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { IWarehouse } from "../models/warehouses.models";
import { IPageCount } from "src/app/shared/models/page.model";

@Injectable({
  providedIn: 'root',
})
export class WarehousesService {

  constructor(private http: HttpClient) { }

  public listAllWarehouses(pagination: IPageCount): Observable<APIResponse<IWarehouse>> {
    const params = new HttpParams()
      .set('page', pagination.number)
      .set('limit', pagination.size);
    return this.http.get<APIResponse<IWarehouse>>(`${environment.BASE_URL_API}warehouses`, { params });
  }
  public createWarehouse(warehouse: Omit<IWarehouse, 'id'>): Observable<APIResponse<IWarehouse>> {
    return this.http.post<APIResponse<IWarehouse>>(`${environment.BASE_URL_API}warehouses`, warehouse);
  }
  public updateWarehouse(id: number, warehouse: Partial<IWarehouse>): Observable<APIResponse<IWarehouse>> {
    return this.http.patch<APIResponse<IWarehouse>>(`${environment.BASE_URL_API}warehouses/${id}`, warehouse);
  }
  public deleteWarehouse(id: number): Observable<APIResponse<void>> {
    return this.http.delete<APIResponse<void>>(`${environment.BASE_URL_API}warehouses/${id}`);
  }
}
